<script setup lang="ts">
import {CustomNodeProps} from "@/core/interfaces/flowchart/flowchart";
import {Popover, PopoverContent, PopoverTrigger} from "@/core/components/ui/popover";
import {MessageCircleQuestionIcon} from "@lucide/vue";
import CustomNodeCriteria from "@/flowcharts/Components/CustomNodeCriteria.vue";

defineProps<{
    data: CustomNodeProps;
}>();
</script>

<template>
  <Popover v-if="data.description">
    <!-- Stopped so that reading the criteria neither selects the node nor opens its action. -->
    <PopoverTrigger
      class="cursor-pointer text-xs absolute -right-3 -top-3 bg-white p-1 rounded-full shadow"
      @click.stop
    >
      <MessageCircleQuestionIcon :size="16" class="text-muted-foreground" />
    </PopoverTrigger>
    <PopoverContent
      class="w-auto p-2 max-h-[min(70vh,var(--reka-popper-available-height))] overflow-y-auto"
      :collision-padding="16"
    >
      <CustomNodeCriteria :description="data.description" />
    </PopoverContent>
  </Popover>
</template>
